export default __webpack_public_path__ + "static/media/etched.11bb85a2.png";